<template>
  <div class="addedToCartModal">
  	   <div class="title"> <i class="fa fa-check"></i> {{ $t('waresAddedToCart') }} </div>
       <div class="loading"> <loader :loading="true"> </loader> </div>
       <div class="message raleway"> {{ $t('proceedingToCheckout') }}   </div>
  </div>
</template>

<script>

export default {
  data: function(){ 
    return{
    }
  },

  methods: { 
    
  },

  mounted: function () { 

    var self = this;

    // Redirect after some time
    setTimeout(function(){
      window.eventHub.$emit('closeModal')
      window.location.href = window.appSettings.getUrl() + "/cgi-bin/ibutik/AIR_ibutik.fcgi?funk=bestall_steg1&KCO=Y";
    }, 1500);

  }

}
</script>

<style>

.addedToCartModal{

  .loading{
    font-size: 51px;
    text-align: center;
    margin: 32px 0 0 0;
  }

  .message{
    margin-top: 10px;
    text-align: center;
    text-transform: uppercase;
  }

}

</style>



// WEBPACK FOOTER //
// AddedToCart.vue?43be0869